export const AGENT_MENU_LIST = [
  {
    title: "Dashboard",
    iconStyle: <i className="flaticon-381-app"></i>,
    to: "/dashboard",
  },
  {
    title: "Api Management",
    iconStyle: <i className="flaticon-381-networking"></i>,
    to: "/api-management",
  },
  {
    title: "Topup",
    iconStyle: <i className="flaticon-381-transfer"></i>,
    to: "/top-up",
  },
  {
    title: "Customer",
    iconStyle: <i className="flaticon-381-user"></i>,
    to: "/customer",
  },
  {
    title: "Beneficiary",
    iconStyle: <i className="flaticon-381-user-1"></i>,
    to: "/beneficiaries",
  },
  {
    title: "Transaction Activity",
    iconStyle: <i className="flaticon-381-list"></i>,
    to: "/transaction-activity",
  },
];

export const MenuList = AGENT_MENU_LIST;
